'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import UILink from 'UIComponents/link/UILink';
import UIRouterLink from 'ui-addon-react-router-dom/UIRouterLink';
import CodeLink from './CodeLink.js';

function Code(props) {
  return /*#__PURE__*/_jsx("code", {
    children: props.message
  });
}

function MinificationErrorComponent(props) {
  const {
    message,
    options
  } = props.error;
  return /*#__PURE__*/_jsx(FormattedJSXMessage, {
    message: message,
    options: options,
    elements: {
      Link: UILink,
      RouterLink: UIRouterLink,
      Code,
      CodeLink
    }
  });
}

export const ERROR_MESSAGE_COMPONENTS = {
  MINIFICATION_ERROR_COMPONENT: MinificationErrorComponent
};